import Propose from "./Propose";

export default Propose